import { render } from "./ParentProfile.vue?vue&type=template&id=25f9ee74&scoped=true"
import script from "./ParentProfile.vue?vue&type=script&lang=js"
export * from "./ParentProfile.vue?vue&type=script&lang=js"

import "./ParentProfile.vue?vue&type=style&index=0&id=25f9ee74&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25f9ee74"]])

export default __exports__